export const shallowArrayEqual = (arr1: any[], arr2: any[]) => {
  if (arr1.length !== arr2.length) return false;

  return arr1.every((x, i) => x === arr2[i]);
};
